module.exports = __webpack_public_path__ + "img/q.b51ce42a.jpg";